import api from './api'

const notificationService = {
  // 取得通知列表
  getNotifications: async (params) => {
    return api.get('/notifications', { params })
  },

  // 取得未讀數量
  getUnreadCount: async () => {
    return api.get('/notifications/unread-count')
  },

  // 標記為已讀
  markAsRead: async (id) => {
    return api.post(`/notifications/${id}/read`)
  },

  // 全部標記為已讀
  markAllAsRead: async () => {
    return api.post('/notifications/read-all')
  },

  // 刪除通知
  deleteNotification: async (id) => {
    return api.post(`/notifications/${id}/delete`)
  },

  // 發送自訂通知（管理員）
  sendCustom: async (data) => {
    return api.post('/notifications/send', data)
  },

  // 取得通知模板
  getTemplates: async (params) => {
    return api.get('/notifications/templates', { params })
  },

  // 更新通知模板
  updateTemplate: async (id, data) => {
    return api.put(`/notifications/templates/${id}`, data)
  },

  // 初始化預設模板
  initializeTemplates: async () => {
    return api.post('/notifications/initialize-templates')
  },
}

export default notificationService
